import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { DocumentsListPage } from '@/features/documents/documents-list-page'

const searchSchema = z.object({
  q: z.string().optional(),
  status: z.string().optional(),
  payment: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  branchId: z.string().optional(),
  noteKind: z.enum(['NC', 'ND']).optional(),
  page: z.number().int().min(1).optional(),
})

export const Route = createFileRoute('/_app/notes')({
  staticData: { crumb: 'Notas' },
  validateSearch: searchSchema,
  component: Page,
})

function Page() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <DocumentsListPage
      kind="NOTES"
      title="Notas de crédito y débito"
      description="Correcciones y anulaciones de comprobantes emitidos. Se crean desde el comprobante original."
      search={search}
      onSearch={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
    />
  )
}
